import { StyleSheet } from '@react-pdf/renderer'

export const PRINT_FORMAT_OPTIONS = [
  {
    value: 'letter',
    label: 'Letter'
  },
  {
    value: '80mm',
    label: '80mm Pageless'
  }
]

const TEXT_COLOR = '#000000'

export const styleSheet = StyleSheet.create({
  page: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    alignContent: 'flex-start',
    backgroundColor: '#FFF',
    fontFamily: 'Roboto',
    paddingTop: 50,
    paddingBottom: 40,
    paddingLeft: 10,
    paddingRight: 10
  },
  row: {
    display: 'flex',
    flex: 0,
    flexDirection: 'row'
  },
  col: {
    flex: 1
  },
  brand: {
    alignItems: 'center',
    flex: 1
  },
  headerCol: {
    display: 'flex',
    flex: 2,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    alignContent: 'flex-start'
  },
  headerMore: {
    position: 'absolute',
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    fontFamily: 'Roboto',
    fontSize: 8,
    color: TEXT_COLOR,
    paddingLeft: 30,
    paddingRight: 30,
    top: 40,
    left: 0,
    right: 0
  },
  textRow: {
    display: 'flex',
    flex: 0,
    flexDirection: 'row',
    marginBottom: 10
  },
  logoImage: {
    width: '70px',
    marginTop: '2px',
    marginBottom: '2px'
  },
  powered: {
    width: '138px',
    marginTop: '13px'
  },
  detailsLabel: {
    fontSize: 10,
    color: TEXT_COLOR,
    flex: 3,
    marginRight: 5,
    fontFamily: 'Roboto'
  },
  detailsText: {
    fontSize: 10,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: TEXT_COLOR,
    flex: 4,
    marginRight: 5
  },
  detailsTextLG: {
    fontSize: 10,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: TEXT_COLOR,
    flex: 11,
    marginRight: 5
  },
  text: {
    fontSize: 8,
    fontFamily: 'Roboto',
    color: TEXT_COLOR
  },
  textSKU: {
    fontSize: 7,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: TEXT_COLOR
  },
  smallText: {
    fontSize: 7,
    fontFamily: 'Roboto',
    color: TEXT_COLOR
  },
  bold: {
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: 8
  },
  center: {
    textAlign: 'center'
  },
  right: {
    textAlign: 'right'
  },
  package: {
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: 8,
    margin: 8,
    color: TEXT_COLOR
  },
  footer: {
    position: 'absolute',
    display: 'flex',
    bottom: 20,
    left: 0,
    right: 0,
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    fontFamily: 'Roboto',
    fontSize: 8,
    color: TEXT_COLOR,
    paddingLeft: 25,
    paddingRight: 25
  }
})

export const styles80mm = StyleSheet.create({
  label: { fontSize: 10, marginRight: 3 },
  text: { fontSize: 10, fontWeight: 'bold' },
  row: { display: 'flex', flexDirection: 'row' },
  marginTop15: { marginTop: 15 },
  capitalize: { textTransform: 'capitalize' },
  paddingLeft: { paddingLeft: 10 },
  fullWidth: { width: '100%' },
  marginBottom7: { marginBottom: 7 },
  col: { display: 'flex', flexDirection: 'column' },
  marginTop7: { marginTop: 7 }
})

export const STATES = {
  PENDING: 'PENDING',
  ADDED: 'ADDED',
  REMOVED: 'REMOVED',
  CANCELLED: 'CANCELLED',
  REJECTED: 'REJECTED'
}

export const getState = (st) => {
  let _state = st === STATES.CANCELLED ? STATES.REMOVED : st
  _state = _state.startsWith(STATES.REJECTED) ? STATES.REJECTED : _state
  return _state
}

export const calculate80mmPageHeight = (packages) => {
  const logoHeight = 160
  const infoRowsHeight = 14 * 18
  const marginY = 45
  const rowPackageHeight = 30
  const totalPackages = packages.reduce((acc, { package: _package }) => acc + (!!_package ? 1 : 0), 0)
  const totalRowsPackagesHeight = totalPackages * rowPackageHeight
  return (
    totalRowsPackagesHeight +
    logoHeight +
    infoRowsHeight +
    marginY +
    (packages
      ? packages.reduce((acc, { categories }) => {
          return (
            acc +
            Object.keys(categories).reduce((catAcc, category) => {
              const items = categories[category] || []
              const rowsPerItem = 5
              const margin = 21
              const categoryHeight = 13
              const footerHeight = 20
              const productNameHeight = items.reduce((itemAcc, item) => {
                const itemNameHeight = 13
                return itemAcc + (item.name.length / 24) * itemNameHeight
              }, 0)
              const itemRowHeight = 11
              return (
                catAcc +
                categoryHeight +
                productNameHeight +
                items.length * itemRowHeight * rowsPerItem +
                margin +
                footerHeight
              )
            }, 0)
          )
        }, 0)
      : 0)
  )
}
